import {
  SvgIcon,
  Checkbox,
  Card,
  Theme,
  CardHeader,
  Avatar,
  TextField,
  Collapse,
  IconButton,
  CardContent,
  Typography,
  CardActions,
  Tooltip,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import Autocomplete from "@mui/material/Autocomplete";
import { Delete, Edit, Save } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import clsx from "clsx";
import React, { useState } from "react";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { parseISO, parse } from "date-fns";
import { PetRecord, VetRecord } from "../repositories/types";

const DogLeashIcon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 512 512">
    <path d="m498.466 102.204-51.055-8.509c-10.102-25.046-33.425-43.123-60.733-46.157l-19.021-2.113-30-3.333c-.551-.062-1.103-.092-1.657-.092-24.813 0-45 20.187-45 45v40c0 5.422.964 10.623 2.73 15.441-3.08 7.411-7.612 14.008-13.226 19.463l-205.328-158.77c-2.628-2.031-5.855-3.134-9.176-3.134h-50c-8.284 0-15 6.716-15 15s6.716 15 15 15h44.877l190.487 147.295c-1.426.289-2.869.527-4.327.709l-122.82 15.353c-4.448.556-8.793 1.416-13.016 2.558l-17.823-10.29c-18.864-10.892-30.963-30.371-32.366-52.107-.681-10.573-8.071-19.297-18.387-21.708-10.316-2.416-20.808 2.133-26.105 11.308-.015.025-.03.052-.044.077-14.617 25.358-19.062 55.022-12.515 83.534 5.714 24.882 19.32 46.925 38.732 63.062-1.108 5.789-1.693 11.75-1.693 17.831v64.116l-36.713 45.892c-2.128 2.659-3.287 5.964-3.287 9.37v90c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-58.246c35.427-11.409 60-44.336 60-82.581v-5.878l25.067 11.395c21.049 9.568 42.743 16.868 64.933 21.917v113.393c0 8.284 6.716 15 15 15h60 60c8.284 0 15-6.716 15-15v-140.446c30.681-16.305 50-48.022 50-83.405v-81.149h15c30.327 0 55-24.673 55-55v-20c0-7.333-5.301-13.591-12.534-14.796zm-177.466-15.204c0-8.04 6.358-14.623 14.311-14.984l15.689 1.743v53.241c0 8.271-6.729 15-15 15s-15-6.729-15-15zm-286.278 69.134c6.792 23.172 22.242 43.107 43.656 55.471l.42.243c-9.913 7.505-18.281 16.885-24.604 27.585-20.715-22.223-28.179-54.244-19.472-83.299zm236.278 232.878c9.921 1.323 19.922 2.224 30 2.663v90.325h-30zm99.43-55.939c-5.695 2.277-9.43 7.793-9.43 13.927v135h-30v-105c0-3.374-1.128-6.478-3.008-8.984l.008-.016-6-8c-13.542-18.056-21-40.43-21-63 0-8.284-6.716-15-15-15s-15 6.716-15 15c0 22.144 5.599 44.131 15.981 63.626-34.024-3.18-67.049-11.952-98.499-26.247l-46.274-21.034c-4.644-2.111-10.041-1.718-14.328 1.044-4.289 2.76-6.88 7.511-6.88 12.611v29.173c0 27.883-19.962 51.447-47.466 56.031-7.233 1.205-12.534 7.463-12.534 14.796v55h-30v-69.738l36.713-45.892c2.128-2.659 3.287-5.964 3.287-9.37v-69.378c0-32.713 24.478-60.44 56.937-64.498l122.82-15.353c10.001-1.25 19.525-4.188 28.265-8.526 35.264 28.64 79.391 44.154 124.49 44.154 2.493 0 4.99-.064 7.488-.16v29.909c0 26.545-15.925 50.067-40.57 59.925zm110.57-196.073c0 13.785-11.215 25-25 25h-30c-8.284 0-15 6.716-15 15v36.23c-38.246 1.722-76.109-9.793-106.933-32.528 4.037-4.273 7.663-8.953 10.799-13.988 6.306 3.369 13.499 5.286 21.134 5.286 24.813 0 45-20.187 45-45v-49.908l2.365.263c18.31 2.034 33.614 15.41 38.083 33.284 1.448 5.793 6.195 10.176 12.086 11.157l47.466 7.911z" />
  </SvgIcon>
);

interface PetCardProps {
  pet: PetCardPet;
  vets: VetRecord[];
  save: (pet: PetCardPet) => void;
  delete: (id: string, isNew: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      margin: "4px",
      [theme.breakpoints.up("sm")]: {
        width: "45%",
      },
      [theme.breakpoints.down("md")]: {
        width: "95%",
      },
      "flex-direction": "column",
    },
    cardHeader: {
      display: "flex",
    },
    content: {
      display: "flex",
      "justify-content": "space-around",
    },
    expand: {
      transform: "rotate(0deg)",
      marginLeft: "auto",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: "rotate(180deg)",
    },
    collapseDetails: {
      display: "flex",
      "flex-wrap": "wrap",
      "justify-content": "center",
      "flex-direction": "column",
      "align-items": "center",
    },
    notesContainer: {
      width: "100%",
    },
    checkBoxes: {
      "align-items": "center",
    },
  })
);

const PetCard: React.FC<PetCardProps> = (props: PetCardProps) => {
  const classes = useStyles();
  const [pet, setPet] = useState({ ...props.pet, neutering: props.pet.Neutered ? "Yes" : "No" });
  const [vet, setVet] = useState<VetRecord | null>(props.pet.vet ?? null);
  const [isEditable, setEditable] = useState(props.pet.editable);
  const [expanded, setExpanded] = useState(isEditable);
  const [petNameError, setPetNameError] = useState(false);

  const savePet = () => {
    if (!pet.Name) {
      setPetNameError(true);
      return;
    }
    props.save(pet);
    setPet({ ...pet, isNew: false });
    setEditable(false);
  };

  const vaccinationsValid = () => {
    if (!isEditable) {
      let colour = "";
      let due = "";
      if (!pet.VaccinationDue) {
        colour = "orange";
        due = "Not set";
      } else {
        const date = Date.parse(pet.VaccinationDue);
        if (date > Date.now()) {
          colour = "green";
          due = "No";
        } else {
          colour = "red";
          due = "Yes";
        }
      }
      return (
        <Tooltip title={`Vaccination Due - ${due}`}>
          <LocalHospitalIcon style={{ fill: colour }} />
        </Tooltip>
      );
    }
  };

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.cardHeader}
        avatar={<Avatar aria-label="pet">P</Avatar>}
        action={
          <>
            {isEditable ? (
              <IconButton aria-label="Save Pet" onClick={savePet} size="large">
                <Save />
              </IconButton>
            ) : (
              <IconButton aria-label="Edit Pet" onClick={() => setEditable(true)} size="large">
                <Edit />
              </IconButton>
            )}
            <IconButton aria-label="Delete Pet" onClick={() => props.delete(pet.id, pet.isNew)} size="large">
              <Delete />
            </IconButton>
          </>
        }
        title={
          !isEditable ? (
            pet.Name
          ) : (
            <TextField
              id="petName"
              aria-label="Pet Name"
              value={pet.Name}
              error={petNameError}
              required
              helperText={petNameError ? "Name must be provided" : ""}
              placeholder="Pet Name"
              onChange={(e) => {
                setPetNameError(false);
                setPet({ ...pet, Name: e.target.value });
              }}
            />
          )
        }
      />
      <CardContent className={classes.content}>
        {vaccinationsValid()}
        {!isEditable ? (
          <>
            <Tooltip title={pet.TermsAccepted ? "T's & C's Accepted" : "T's & C's Not Accepted"}>
              <AssignmentTurnedInIcon style={{ fill: pet.TermsAccepted ? "green" : "red" }} />
            </Tooltip>
            {pet.Type === "Dog" && (
              <Tooltip title={pet.OffLead ? "Walk Off Lead" : "Don't Walk Off Lead"}>
                <div>
                  <DogLeashIcon style={{ fill: pet.OffLead ? "green" : "red" }} />
                </div>
              </Tooltip>
            )}
          </>
        ) : (
          <FormGroup className={classes.checkBoxes}>
            <FormControlLabel
              label="Accepted T's & C's"
              control={
                <Checkbox
                  checked={pet.TermsAccepted ?? false}
                  onChange={(e) => setPet({ ...pet, TermsAccepted: e.target.checked })}
                />
              }
            />
            <FormControlLabel
              label="Walk Off Lead"
              control={
                <Checkbox
                  checked={pet.OffLead ?? false}
                  onChange={(e) => setPet({ ...pet, OffLead: e.target.checked })}
                />
              }
            />
          </FormGroup>
        )}
      </CardContent>
      <CardActions>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          aria-label="show more"
          size="large"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapseDetails}>
        <div className={classes.notesContainer}>
          <EditableField
            multiline
            label="Notes"
            isEditable={isEditable}
            value={pet.Notes ?? ""}
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setPet({ ...pet, Notes: e.target.value })}
          />
        </div>
        <div className={classes.collapseDetails}>
          <EditableField
            label="Type"
            isEditable={isEditable}
            value={pet.Type ?? ""}
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setPet({ ...pet, Type: e.target.value })}
          />
          <EditableField
            label="Breed"
            isEditable={isEditable}
            value={pet.Breed ?? ""}
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setPet({ ...pet, Breed: e.target.value })}
          />
          <Typography component="div">
            <Grid component="label" container alignItems="center" spacing={1}>
              <Grid>
                <FormControl disabled={!isEditable} component="fieldset">
                  <FormLabel component="legend">Sex</FormLabel>
                  <RadioGroup
                    row
                    aria-label="sex"
                    name="sex"
                    value={pet.Sex?.toUpperCase()}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const sex = e.target.value;
                      setPet({ ...pet, Sex: sex });
                    }}
                  >
                    <FormControlLabel value="FEMALE" control={<Radio />} label="Female" />
                    <FormControlLabel value="MALE" control={<Radio />} label="Male" />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Typography>
          {/* <EditableField
            label="Sex"
            isEditable={isEditable}
            value={pet.Sex ?? ""}
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setPet({ ...pet, Sex: e.target.value })}
          /> */}
          <FormControlLabel
            label="Neutered?"
            control={
              <Checkbox
                disabled={!isEditable}
                checked={pet.Neutered ?? false}
                onChange={(e) => setPet({ ...pet, Neutered: e.target.checked })}
              />
            }
          />
        </div>
        {isEditable ? (
          <DatePicker
            format="dd/MM/yyyy"
            label="Next Vaccination Due"
            slotProps={{
              textField: {
                required: true,
                id: "next-vaccination-due",
                "aria-label": "change date",
              },
            }}
            closeOnSelect
            value={pet.VaccinationDue && pet.VaccinationDue !== "" ? parse(pet.VaccinationDue, "EEE MMM dd yyyy", new Date()) : parseISO("")}
            onChange={(date: Date | null) => setPet({ ...pet, VaccinationDue: date?.toDateString() ?? "" })}
          />
        ) : (
          <div>
            <Typography variant="caption" display="block" gutterBottom>
              Vaccination Next Due
            </Typography>
            <Typography>{pet.VaccinationDue ?? "-"}</Typography>
          </div>
        )}
        {isEditable ? (
          <Autocomplete
            id="vetInput"
            options={props.vets}
            getOptionLabel={(o) => o.name ?? ""}
            renderInput={(params) => <TextField {...params} label="Vet" />}
            onChange={(e: any, newValue: VetRecord | null) => {
              setPet({ ...pet, vetID: newValue?.id ?? null });
              setVet(newValue);
            }}
            value={vet}
          />
        ) : (
          <div>
            <Typography variant="caption" display="block" gutterBottom>
              Vet
            </Typography>
            <Typography>{vet ? vet.name : "-"}</Typography>
            <Typography>{vet ? vet.phoneNumber : "-"}</Typography>
          </div>
        )}
      </Collapse>
    </Card>
  );
};

interface EditableFieldProps {
  isEditable: boolean;
  label: string;
  value: string;
  multiline?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const EditableField: React.FC<EditableFieldProps> = (props: EditableFieldProps) => {
  const { isEditable, label, value, multiline, handleChange } = props;
  if (isEditable) {
    return <TextField multiline={multiline} label={label} value={value} onChange={handleChange} />;
  } else {
    return (
      <div>
        <Typography variant="caption" display="block" gutterBottom>
          {label}
        </Typography>
        <Typography>{value ? value : "-"}</Typography>
      </div>
    );
  }
};

export interface PetCardPet extends PetRecord {
  editable: boolean;
  isNew: boolean;
  neutering?: string;
}

export default PetCard;
